import { Dialog, DialogActions, DialogContent, DialogTitle, Slide, Typography, useTheme } from '@mui/material';
import React from 'react';
// import Paper, { PaperProps } from '@mui/material/Paper';
// import Draggable from 'react-draggable';

import { TransitionProps } from '@mui/material/transitions';
import SercomButton from './SercomButton';
import { t } from 'i18next';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface SercomDialogProps {
  title: string;
  isOpen: boolean;
  onClose: any;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  fullWidth?: boolean;
  paperWidth?: string;
  buttonText?: string;
  closeButtonText?: string;
  actionDisabled?: boolean;
  action: any;
  children: any;
}

const SercomDialog = (props: SercomDialogProps) => {
  const theme = useTheme();
  // function PaperComponent(props: PaperProps) {
  //   return (
  //     <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
  //       <Paper {...props} />
  //     </Draggable>
  //   );
  // }
  // const onClick = () => {
  //   props.action();
  // };

  return (
    <Dialog
      // fullScreen
      scroll="paper"
      disableRestoreFocus
      open={props.isOpen}
      onClose={props.onClose}
      maxWidth={props.maxWidth}
      fullWidth={props.fullWidth}
      PaperProps={props.paperWidth ? { sx: { width: props.paperWidth, maxWidth: 'calc(100% - 48px)' } } : undefined}
      // PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      TransitionComponent={Transition}
    >
      <DialogTitle id="draggable-dialog-title" sx={{ mt: 1, mb: 1 }}>
        <Typography variant="h3" color={theme.palette.secondary.main}>
          {props.title}
        </Typography>
      </DialogTitle>
      <DialogContent>{props.children}</DialogContent>
      <DialogActions sx={{ mr: 2, mb: 2 }}>
        <SercomButton text={props.closeButtonText ?? t('Cancel')} variant={props.buttonText ? 'text' : 'contained'} onClick={props.onClose} />
        {props.buttonText && <SercomButton text={props.buttonText} variant="contained" disabled={props.actionDisabled} onClick={props.action} />}
      </DialogActions>
    </Dialog>
  );
};

export default SercomDialog;
